import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";

const VideoComparison = () => {
  const navigate = useNavigate();
  const handleGoBack = () => {
    navigate(-1);
  };
  return (
    <div>
      <button
        onClick={handleGoBack}
        className="flex gap-x-1.5 items-center text-base font-semibold"
      >
        <ArrowLeft size={15} /> Back to structure
      </button>
      <div className="space-y-2 mb-8 mt-6">
        <h1 className="text-gray-900 text-2xl font-semibold">
          Video Comparison
        </h1>
        <p className="text-gray-500 text-sm">
          Compare enhance and comparison videos
        </p>
      </div>
      <div className="flex flex-col md:flex-row gap-6">
        <div className="w-full">
          <label className="text-xl font-semibold tracking-[-1%] leading-5 mb-4 block">
            Original Video
          </label>
          <video
            controls
            className="w-full h-[400px] bg-gray-200 object-contain rounded-lg"
            src="https://passionbits-v2-dashboard-public-assets.s3.ap-south-1.amazonaws.com/BlinkIt.mp4"
          />
        </div>
        <div className="w-full">
          <label className="text-xl font-semibold tracking-[-1%] leading-5 mb-4 block">
            Enhanced Video
          </label>
          <video
            controls
            className="w-full h-[400px] bg-gray-200 object-contain rounded-lg"
            src="https://passionbits-v2-dashboard-public-assets.s3.ap-south-1.amazonaws.com/BlinkIt.mp4"
          />
        </div>
      </div>
    </div>
  );
};

export default VideoComparison;
